import React, {useState} from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Stack,
  SvgIcon,
  TextField,
  Typography
} from "@mui/material";
import localStrings from "../../../localStrings";
import XIcon from "@untitled-ui/icons-react/build/esm/X";
import * as Yup from "yup";
import {Autocomplete} from "@mui/lab";
import {ROLE_USER, roles} from "./brandUsers";

function AddUserDialog({onClose, open, selectCallBack}) {
  const [emailUser, setEmailUser] = useState("");
  const [role, setRole] = useState(ROLE_USER);

  function isMailValid(emailUser) {
    try {
      Yup.string().email().validateSync(emailUser);
      return true;
    }
    catch (err) {
    }
    return false;
  }

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={onClose}
    >
      <Stack
        alignItems="center"
        direction="row"
        justifyContent="space-between"
        spacing={3}
        sx={{
          px: 3,
          py: 2
        }}
      >
        <Typography variant="h6">
          {localStrings.inviteUser}
        </Typography>
        <IconButton
          color="inherit"
          onClick={onClose}
        >
          <SvgIcon>
            <XIcon />
          </SvgIcon>
        </IconButton>
      </Stack>
      <DialogContent>
        <TextField
          inputProps={{
            autocomplete:"new-password"
          }}
          error={Boolean(!isMailValid(emailUser))}
          fullWidth
          helperText={!isMailValid(emailUser) ? localStrings.check.badEmailFormat : null}
          label={localStrings.email}
          name="emailUser"
          onChange={(event) => setEmailUser(event.target.value)}
          required
          value={emailUser}
          sx={{marginBottom: 1}}
        />

        {/*<Autocomplete*/}
        {/*  //multiple*/}
        {/*  filterSelectedOptions*/}
        {/*  onChange={(event, newValue) => {*/}
        {/*    setRole(newValue)*/}
        {/*  }}*/}
        {/*  options={roles}*/}
        {/*  value={role}*/}
        {/*  getOptionLabel={(role) => localStrings.roleList[role]}*/}
        {/*  renderInput={(params) => (*/}
        {/*    <TextField*/}
        {/*      {...params}*/}
        {/*      label={localStrings.roles}*/}
        {/*      placeholder={localStrings.roles}*/}
        {/*    />*/}
        {/*  )}*/}
        {/*/>*/}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}
                color="primary"
                autoFocus>
          {localStrings.cancel}
        </Button>
        <Button
          disabled={!isMailValid() || !role}
          onClick={() => {
            onClose();
            if (selectCallBack) {
              selectCallBack(emailUser, role);
            }
          }}
          color="primary"
          //disabled={checkBoxesSelected.length == 0}
        >
          {localStrings.confirm}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddUserDialog;
